import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [RiskLevel.Low, [{ lower: 0, upper: 3 }]],
      [RiskLevel.Medium, [{ lower: 3, upper: 4 }]],
      [RiskLevel.High, [{ lower: 4, upper: 5 }]],
    ]),
  ],
]);

export default referenceRange;
